
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#75AF2B","d":"M.6.2H512v341H.6z"}}),_c('path',{attrs:{"fill":"#D32424","d":"M0 230h512V.2H0"}}),_c('path',{attrs:{"fill":"#FFF","d":"M100.1 230V.2H0v340.9h511.4-411.3z"}}),_c('path',{attrs:{"fill":"#D32424","d":"M51.6 218l-38-47.7 38-46.9 38 46.9zM51.6 113.4l-38-47.7 38-46.9 38 46.9zM51.6 322.6l-38-47.7 38-46.9 38 46.9z"}})])
          )
        }
      }
    